import { GameManager, type Canvas } from './types';
import { setButtonState, buttonStates, clearTypedKeys } from './input';
import { scrollCanvas, zoomCanvas } from './canvas';
import { createAddAndPlaceUserText } from './user_text';
import { ObjectType } from './shared/api_shared_types';
import { v2, clamp, hasVisibleState } from './helpers';

import { frameNr } from '.';
import logger from './controllers/logger';

export function mouseOut(manager: GameManager, event?: MouseEvent) {
  const cursor = manager.cursor;
  manager.cursor.enabled = true;

  if (buttonStates.LEFT_MOUSE.isDown && (event === undefined || event.relatedTarget === null)) {
    setButtonState(buttonStates.LEFT_MOUSE, false);
  }

  for (let i = 0; i < cursor.highlightEntities.length; i++) {
    cursor.highlightEntities[i].highlighted = false;
    cursor.highlightEntities[i].stopHighlightThisFrame = true;
  }
  cursor.highlightEntities = [];
  cursor.highlightTopEntity = null;
}

export function mouseOver(manager: GameManager) {
  manager.cursor.enabled = false;
}

export function scroll(e: WheelEvent, manager: GameManager) {
  if (!manager.preventScroll) return;
  e.preventDefault();

  manager.cursor.idleTime = 0;

  if (manager.mousePos.x === 0 && manager.mousePos.y === 0) {
    manager.mousePos.x = e.clientX;
    manager.mousePos.y = e.clientY;
  }

  let canvasToZoom: Canvas = null;
  let canvasToScroll: Canvas = null;

  if (manager.cursor.highlightTopEntity) {
    const id = manager.cursor.highlightTopEntity.id;
    const obj = manager.gameObjectIdTable[id];
    if (obj && hasVisibleState(obj.visibilityState) && obj.objectType === ObjectType.CANVAS) {
      if (obj.allowZoom) {
        canvasToZoom = obj;
      }
      if (obj.allowScrollHor || obj.allowScrollVert) {
        canvasToScroll = obj;
      }
    }
  }

  if (!canvasToScroll || !canvasToZoom) {
    for (let i = 0; i < manager.cursor.highlightCanvasses.length; i++) {
      const canvasToCheck = manager.cursor.highlightCanvasses[i];

      if (!canvasToCheck.allowHighlight) continue;
      if (!hasVisibleState(canvasToCheck.visibilityState)) continue;

      if (canvasToCheck.mouseOver) {
        if (!canvasToZoom && e.ctrlKey && canvasToCheck.allowZoom) {
          canvasToZoom = canvasToCheck;
        } else if (
          !canvasToScroll &&
          (canvasToCheck.allowScrollVert || canvasToCheck.allowScrollHor)
        ) {
          canvasToScroll = canvasToCheck;
        }
      }
    }
  }

  if (canvasToScroll && !e.ctrlKey && (e.deltaX || e.deltaY)) {
    const diff = v2(-e.deltaX, -e.deltaY);
    scrollCanvas(canvasToScroll, diff);
  }
  if (canvasToZoom && e.ctrlKey) {
    const zoomValue = clamp(e.deltaY, -25, 25);
    zoomCanvas(canvasToZoom, zoomValue, manager.cursor.pos);
  }
}

let lastPasteTime = 0;

export function onClipboardPaste(event: ClipboardEvent, manager: GameManager) {
  const now = Date.now();
  if (now - lastPasteTime < 500) return;
  lastPasteTime = now;

  if (manager.paused) return;

  const clipText = event.clipboardData.getData('Text');

  logger.merijn(frameNr, clipText);

  if (clipText) {
    if (manager.cursor.text.length > 0) {
      manager.cursor.text += clipText;
      manager.cursor.changed = true;
    } else {
      if (manager.cursor.allowTyping) {
        createAddAndPlaceUserText(manager, clipText, manager.cursor.pos);
      }
    }
    clearTypedKeys();
  }
}

export function handleFileDrop(ev: DragEvent, manager: GameManager) {
  const fileList = new DataTransfer();
  const list = [...ev.dataTransfer.files];
  for (let i = 0; i < list.length; i++) {
    fileList.items.add(list[i]);
    break;
  }
}
